import { ClientError } from 'graphql-request';

export const SSO_TOKEN_REQUIRED = 'SSO_TOKEN_REQUIRED';
export const SSO_TOKEN_EXCHANGE_FAILED = 'SSO_TOKEN_EXCHANGE_FAILED';

export const getGraphQLErrorCode = (error: unknown): string | undefined => {
  if (!(error instanceof ClientError)) {
    return undefined;
  }
  const firstError = error.response.errors?.[0];
  return firstError?.extensions?.code as string | undefined;
};
